import type { ReactNode } from 'react';

export const symbol_find_in_page: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-80q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h345q13.28 0 25.08 5.43Q601.89-869.14 610-859l175 201q8 8 11.5 18.08Q800-629.85 800-619v471q0 20.11-18.5 27.55Q763-113 749-127L562-314q-20 12-39.68 17-19.69 5-42.32 5-62 0-104.5-42.5T333-439q0-62 42.5-104.5T480-586q62 0 104.5 42.5T627-439q0 23-6.5 44T601-358l139 139v-403L568-820H220v680h420q14.5 0 21.75 9.32t7.25 20.5q0 11.18-7.25 20.68T640-80H220Zm322.5-301.5Q567-411 567-450q0-33-26-54.5T480-526q-35 0-61 21.5T393-450q0 39 24.5 68.5T480-352q38 0 62.5-29.5ZM480-450Zm0 0Z"
		/>
	</svg>
);
